'use strict';

module.exports = {
    LANG: 'vi-vn',
    SIGN: 'Đăng nhập',
    REGISTER: 'Đăng ký',
    QUICK_ACCESS: 'Vào nhanh với',
    SIGN_JOIN: 'Đăng nhập hoặc Tham gia miễn phí!',
    NOT_MEMBER: 'Không phải là thành viên?',
    ALREADY_MEMBER: 'Đã là thành viên AliExpress/Alibaba?',
    SHOW_ALL: 'Hiển thị tất cả',
    HIDE: 'Ẩn'
};